<template>
  <Modal
    v-model="_value"
    width="500"
    title='短信RM设置IP/域名'
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onOk">

    <Form :label-width="110">
      <FormItem prop="DomainName" label="选择服务器通道">
      <Select v-model="DomainName" style="width: 220px;">
        <Option v-for="item in DomainNameOptions" :value="item.value" :key="item.value" @on-change="onChange">
          {{item.name}}
        </Option>
      </Select>
      </FormItem>

      <FormItem prop="ip" label="IP/域名">
        <Input v-model="ip" placeholder="IP/域名" style="width: 220px;" @on-change="onChange">
        </Input>
      </FormItem>
      <FormItem prop="port" label="端口">
        <Input v-model="port" placeholder="端口" style="width: 220px;" @on-change="onChange">
        </Input>
      </FormItem>
      <FormItem prop="sms" label="短信内容">
        <Input v-model="sms" type="textarea" :autosize="true" readonly placeholder="短信内容" style="width: 300px;">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'setuprmipsmsmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      businessUserId: null,
    },
    data() {
      return {
        simNum:null,

        //域名选项
        DomainName:null,
        DomainNameOptions: [
          {name: '服务器通道1(两客一危)', value: 1},
          {name: '服务器通道2(运维:N9M)', value: 2},
          {name: '服务器通道2(运维)', value: 3},
          {name: '服务器通道4(简诚)', value: 4},
          {name: '服务器通道5', value: 5},
          {name: '服务器通道6(货运)', value: 6},
        ],

        ip:null,
        port:null,

        sms:null,
      }
    },
    methods: {
      ...mapActions([
        'ShortMessageServ_Send'
      ]),
      onChange(){
        this.sms = '99admin,自动填密码,SMST'+this.DomainName+',2,2,'+this.ip+','+this.port+',0,0,0,0,0!'
      },
      onOk() {
        if (!this.DomainName || this.DomainName === '') {
          this.$Message.error('请选择归属地')
          return
        }
        //共三条短信，对应不同密码
        // console.log(this.simNum.substring(6))

          this.sendSMS('99admin,admin,SMST'+this.DomainName+',2,2,'+this.ip+','+this.port+',0,0,0,0,0!')

          setTimeout(() => {
              this.sendSMS('99admin,JC336699,SMST'+this.DomainName+',2,2,'+this.ip+','+this.port+',0,0,0,0,0!')
            }
            ,1000)

          setTimeout(() => {
              this.sendSMS('99admin,,SMST'+this.DomainName+',2,2,'+this.ip+','+this.port+',0,0,0,0,0!')
            }
            ,2000)

        setTimeout(() => {
            this.sendSMS('99admin,JcBOZSJCB0,SMST'+this.DomainName+',2,2,'+this.ip+','+this.port+',0,0,0,0,0!')
          }
          ,3000)
      },
      sendSMS (content) {
        if (!this.simNum || this.simNum === '') {
          this.$Message.error('请选择SIM卡号')
          return
        }
        store.dispatch('ShortMessageServ_Send', { params: { simNum: this.simNum, content: content } }).then(() => {
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      visibleChange(val) {
        if(val){
          this.simNum = this._initValue
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _businessUserId:{
        get() {
          return this.businessUserId
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules,
          phoneNum: this.phoneNumRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
